import { AppError } from './app-error';
import { NotFoundError } from './not-found-error';
import { ForbiddenError } from './forbidden-error';
import { UnauthorizedError } from './unauthorized-error';
import { BadInputError } from './bad-input-error';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

export const handleError = (err: HttpErrorResponse) => {
  let code;
  let message;

  if (!(err instanceof HttpErrorResponse) && typeof err == 'object')
  {
    message = err['message'];
    code = err['code'] || 500;
  }
  else if (typeof err.error == 'string') {
    message = err.error;
    code = err.status;
  }
  else {
    code = err.error.code || 500;
    message = err.error.message? err.error.message : err.error;
  }

  switch (err.status) {
    case 400:
      return throwError(new BadInputError(code, message ))

    case 401:
      return throwError(new UnauthorizedError(code, message ))

    case 403:
      return throwError(new ForbiddenError(code, message ))

    case 404:
      return throwError(new NotFoundError(code, message ))

      case 409:
        return throwError(new NotFoundError(code, message ))
        
    default:
      return throwError(new AppError(code, message))
  }
}
